import { useTranslation } from '@/contexts/i18n-context';
import { UserEntryLayout } from '@/components/auth/user-entry-layout';
import { UserEntrySuccessCard } from '@/components/auth/user-entry-success-card';
import styles from './forgot-password-page.module.css';
import { Button } from '@/components/button';
import { EmailSvg } from '@/components/svgs/email';

export function ForgotPasswordSuccessPage() {
  const { t } = useTranslation();

  return (
    <UserEntryLayout>
      <UserEntrySuccessCard
        title={t('passwordReset.emailSentTitle')}
        subtitle={t('passwordReset.forgot.success', {
          link: (
            <Button key="contact-support-button" as="a" variant="link" to="/support">
              {t('passwordReset.forgot.linkTxt')}
            </Button>
          ),
        })}
        icon={<EmailSvg className={styles.icon} />}
      />
    </UserEntryLayout>
  );
}
